import EmployerTrainingDetail from './EmployerTrainingDetail';

export default EmployerTrainingDetail;
